import { render } from "./IconGear.vue?vue&type=template&id=d2f66220"
const script = {}
script.render = render

export default script